export enum ProtocolEncryption {
  NON_ENCRYPTED = 'NON_ENCRYPTED',
  SSL = 'SSL',
  TLS = 'TLS',
}
